import { init } from '@/services/init'
import Storage from '@/services/storageLib'
import {
  isTypeBOT,
  lazyLoadLiveAgent,
  emitEventToParentWindow
} from '@/services/utils'
import { GlobalVars } from '@/services/globals'
import state from '../state'
import { dispatchActionOnBroadcast } from '@/services/broadcastChannel/broadcastChannelUtils'
import {
  constantStrings,
  eventType,
  chatWidgetScreenSizes
} from '@/services/constants'

export default {
  updateMqttConnectionStatus({ commit }, data) {
    commit('UPDATE_MQTT_CONNECTION_STATUS', data)
    commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG')
  },

  updateBotRefId({ commit }, data) {
    commit('UPDATE_BOT_REF_ID', data)
  },

  updateWidgetId({ commit }, data) {
    commit('UPDATE_WIDGET_ID', data)
  },

  updateUserId({ commit }, data) {
    commit('UPDATE_USER_ID', data)
  },

  updateUserEmail({ commit }, data) {
    commit('UPDATE_EMAIL_ID', data)
  },

  updateWidgetConfig({ commit }, data) {
    commit('UPDATE_WIDGET_CONFIG', data)
  },

  updateFeatureFlagsList({ commit }, data) {
    commit('UPDATE_FEATURE_FLAGS_LIST', data)
  },

  updateFormEncryptionPublicKey({ commit }, data) {
    commit('UPDATE_FORM_ENCRYPTION_PUBLIC_KEY', data)
  },
  updateBotPCIPolicy({ commit }, data) {
    commit('UPDATE_BOT_PCI_POLICY', data)
  },
  updateCalloutBubble({ commit }, data) {
    commit('UPDATE_CALLOUT_BUBBLE', data)
  },

  updateWidgetStatus({ commit }, data) {
    commit('UPDATE_WIDGET_STATUS', data)
  },

  updateUserMessage({ commit }, data) {
    commit('UPDATE_USER_MESSAGE', data)
  },

  updatePrimaryLanguage({ commit }, data) {
    commit('UPDATE_PRIMARY_LANGUAGE', data)
  },

  updateUserMessageSync({ commit, rootState }) {
    commit('UPDATE_USER_MESSAGE_SYNC')
    const isUserMessageSyncEnabled = rootState.userMessageSyncAcrossTabs
    if (isUserMessageSyncEnabled) {
      GlobalVars.broadcastChannel.addEventListener('message', (event) => {
        const channelName = `netomiWebWidget_${rootState.botRefId}`
        if (event.currentTarget.name === channelName) {
          const dispatchHanlder = dispatchActionOnBroadcast()[event.data.type]
          const dispatchData = event.data.data
          dispatchHanlder(dispatchData)
        }
      })
    }
  },

  minimizeCW({ dispatch, rootState }) {
    const eventAnalyticsMP = rootState.widgetConfig?.eventAnalyticsMP || false
    eventAnalyticsMP &&
      GlobalVars.$segment.global.sendEvent('minimize_button_click')
    const isChatWidgetFullScreen = rootState.isChatWidgetFullScreen
    if (isChatWidgetFullScreen) {
      dispatch('updateChatWindowFullScreenState', !isChatWidgetFullScreen)
    }
    dispatch('toggleChatWindowStatus', false)
    emitEventToParentWindow(
      eventType.UPDATE_PARENT_WINDOW_STYLE,
      chatWidgetScreenSizes.SHOW_SUPPORT_ICON_ONLY
    )
  },

  async init({ dispatch, rootState }) {
    await init()
    // dispatch('updateUserMessageSync') // Sync user messages across tabs using broadcast channel
    if (
      Storage.getLocalStorageData('showCalloutBubblePubsub')?.enabled ===
      undefined
    ) {
      dispatch('updateCalloutBubbleFlagFromPubsub', { enabled: true })
    }
    dispatch('setIsCalloutBubbleEnabled')
    if (
      Storage.getLocalStorageData('overlayStatus') &&
      rootState.widgetConfig?.inactiveOverlay?.inactiveOverlayTimeout
    ) {
      dispatch('updateOverlayStatus', true)
    }
    // initialize liveAgent if chat is ongoing with live agent
    if (!isTypeBOT(state.controlType)) {
      lazyLoadLiveAgent()
    }

    if (Storage.getLocalStorageData('endChatGreetingTriggered')) {
      dispatch('endChat', {
        message: constantStrings.CHAT_ENDED,
        showSessionRestartGreeting: true,
        hideEndChatGreeting: false,
        publishEventToIoT: false
      })
    }
    dispatch('reinitializeCSATRateLimit')
  },
  removeChatWidget({ rootState }) {
    const removeWidgetUrls = rootState.widgetConfig.removeWidgetOnHide
    for (let i = 0; i < removeWidgetUrls?.length; ++i) {
      if (window.parent?.location?.href?.includes(removeWidgetUrls[i])) {
        emitEventToParentWindow(eventType.REMOVE_WIDGET_FROM_PARENT_WINDOW)
      }
    }
  },
  setClientConfig({ commit }, data) {
    commit('SET_CLIENT_CONFIG', data)
  }
}
